import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Dropdown from "../DropdownMenu";
import { selectPortalType } from "./../../../modules/auth/actions";
import StorageUtil from "./../../../utils/storageUtil";
import viewUtility from "./../../../utils/viewUtility";
import { makeStyles } from "@mui/styles";
import styles from "./styles";

const PortalTypeMenu = (props) => {
  const { portalList } = props;
  const  classes  = makeStyles(styles)();
  const history = useHistory();
  const dispatch = useDispatch();
  const { portalType } = useSelector((state) => ({ portalType: state.auth.portalType }));

  const handleSelect = (option) => {
    if (option.value !== portalType.value) {
      StorageUtil.saveObject(viewUtility.PORTAL_TYPE, option);
      dispatch(selectPortalType(option));
      history.push("/");
    }
  };

  return (
    <>
      {portalType ? (
        <Dropdown
          selectedMenuLabelClass={classes.selectedMenuLabel}
          options={portalList}
          hoverEnable={false}
          onSelect={handleSelect}
          currentSelectedMenu={portalType.label}
        />
      ) : null}
    </>
  );
};

export default PortalTypeMenu;
